import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isVirtualizedMenu"];
import UISelect from 'UIComponents/input/UISelect';
import virtualizedMenuRenderer from 'UIComponents/input/utils/virtualizedMenuRenderer';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export function SelectBase(_ref) {
  let {
      isVirtualizedMenu = false
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  let menuRenderer = undefined;
  if (isVirtualizedMenu) {
    menuRenderer = virtualizedMenuRenderer;
  }
  return /*#__PURE__*/_jsx(UISelect, Object.assign({}, spacingProps, rest, {
    menuRenderer: menuRenderer
  }));
}
export const SelectWrapper = props => /*#__PURE__*/_jsx(InputWrapper, Object.assign({}, props));
SelectWrapper.displayName = 'InputWrapper';